import { render, staticRenderFns } from "./ContractEdit.vue?vue&type=template&id=227a8077&scoped=true"
import script from "./ContractEdit.vue?vue&type=script&lang=js"
export * from "./ContractEdit.vue?vue&type=script&lang=js"
import style0 from "./ContractEdit.vue?vue&type=style&index=0&id=227a8077&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227a8077",
  null
  
)

export default component.exports